//#region src/utils/style-helpers.ts
var e = (e) => Object.entries(e).map(([e, t]) => `${e.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${t}`).join("; ");
//#endregion
export { e as convertStyleObjectToCss };
